import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ForgotComponent } from './forgot/forgot.component';
import { RemoteComponent } from './remote/remote.component';
import { RemoteManagerComponent } from './remote-manager/remote-manager.component';

const routes: Routes = [
  { path: 'remote', component: RemoteComponent },
  { path: 'remote/manager', component: RemoteManagerComponent },
  { path: 'forgot', component: ForgotComponent },
  { path: 'login', component: LoginComponent },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GuestRoutingModule { }
